import { configureStore } from '@reduxjs/toolkit';

import thunk from 'redux-thunk';
import authReducer from './Reducer/AuthReducer';
import themeReducer from './Reducer/ThemeReducer';

const store = configureStore({
  reducer: {
    auth: authReducer,
    theme: themeReducer
  },
  middleware: (getDefaultMiddleware) => [
    ...getDefaultMiddleware().concat(thunk)
  ]
});

export default store;